import { withJsonFormsControlProps } from "@jsonforms/react";
import SelectedRewards from "../../campaign/SelectedRewards";

const CampaignSelectedRewardComponent = (props) => {
  const {
    handleChange,
    label,
    data,
    path,
    errors,
    schema,
    uischema,
    required,
    formData,
  } = props;
  return (
    <SelectedRewards
      value={data}
      label={label}
      updateValue={(newVal) => handleChange(path, newVal)}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
      formData={formData}
    />
  );
};

export const CampaignSelectedRewardControl = withJsonFormsControlProps(
  CampaignSelectedRewardComponent
);
